module.exports = __webpack_public_path__ + "static/media/minus.34a82cc5.svg";